import { ReviewClassTranslations } from './types';

export const enTranslations: ReviewClassTranslations = {
    backButton: "Back"
};